<template>
    <div class="chart-container" ref="chartRef"></div>
</template>

<script>
import * as echarts from 'echarts';

export default {
    name: 'EChartsChart',
    props: {
        // 接收父组件传来的 roomList
        roomList: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            chartInstance: null
        };
    },
    mounted() {
        if (this.$refs.chartRef) {
            this.chartInstance = echarts.init(this.$refs.chartRef);
            this.chartInstance.setOption(this.option);
            window.addEventListener('resize', this.handleResize);
        }
    },
    beforeDestroy() {
        if (this.chartInstance) {
            this.chartInstance.dispose();
            this.chartInstance = null;
        }
        window.removeEventListener('resize', this.handleResize);
    },
    watch: {
        // 数据变化自动刷新图表（样式不变）
        roomList: {
            handler() {
                this.chartInstance.setOption(this.option);
            },
            deep: true
        }
    },
    methods: {
        handleResize() {
            if (this.chartInstance) {
                this.chartInstance.resize();
            }
        }
    },
    computed: {
        option() {
            // 动态从 roomList 生成数据
            let source = [['product', '温度', '湿度']];

            this.roomList.forEach(item => {
                if (item.roomName) {
                    source.push([
                        item.roomName,
                        Number(item.temperature) || 0,
                        Number(item.humidity) || 0
                    ]);
                }
            });

            return {
                legend: {},
                tooltip: {},
                dataset: {
                    source: source.length > 1 ? source : [
                        ['product', '温度', '湿度'],
                        ['洗消间', 43.3, 85.8],
                        ['烹饪间', 73.4, 55.1],
                        ['消毒间', 43.3, 85.8],
                        ['净菜间', 73.4, 55.1],
                        ['净肉间', 23.4, 45.1],
                        ['面食间', 23.4, 55.1],
                        ['米饭间', 20.4, 35.1],
                        ['分饭间', 20.4, 35.1],
                        ['包装间', 20.4, 25.1]
                    ]
                },
                xAxis: { type: 'category' },
                yAxis: {},
                series: [
                    {
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#333',
                            fontSize: 12
                        }
                    },
                    {
                        type: 'bar',
                        label: {
                            show: true,
                            position: 'top',
                            color: '#333',
                            fontSize: 12
                        }
                    }
                ]
            };
        }
    }
};
</script>

<style lang="scss" scoped>
.chart-container {
    width: 100%;
    height: 50vh;
}
</style>